import { rcaptureDirs } from './rcapture-dirs.js';
/**
 * Route matcher that matches any number of directories, including none.
 *
 * Matches only at the {@link RouteMatcher.Context.nameOffset entry name beginning}.
 */
export const rmatchDirs = /*#__PURE__*/ rcaptureDirs();
//# sourceMappingURL=rmatch-dirs.js.map